import { PaletteType } from '@material-ui/core';

export const palette = {
  type: 'dark' as PaletteType,
  common: {
    black: '#000',
    white: '#fff',
  },
  default: {
    main: '#0A1149',
    contrastText: '#E8E8E8',
  },
  primary: {
    main: '#7C85FF',
    contrastText: '#070B3F',
  },
  secondary: {
    main: '#CCD1FF',
    contrastText: '#010330',
  },
  error: {
    main: '#FF6C6C',
    contrastText: '#070B3F',
  },
  warning: {
    main: '#FFF170',
    contrastText: '#000',
  },
  info: {
    main: '#262FA8',
    contrastText: '#fff',
  },
  success: {
    main: '#4caf50',
    contrastText: '#fff',
  },
  text: {
    primary: '#E8E8E8',
    secondary: '#B6B6B6',
    error: '#FF6C6C',
    warning: '#FFF170',
    info: '#7C85FF',
    success: '#4caf50',
  },
  background: {
    default: '#0A1149',
    paper: '#070B3F',
    element: '#010330',
  },
  gradient: {
    primary:
      'linear-gradient(172.92deg, #000330 5.52%, #122081 82%, #00BBC7 116.76%)',
    info: 'linear-gradient(120deg, #fff170, #7C85FF)',
  },
};
